import axios from "axios";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

export const RecipeOptions = async () => {
  const headers = {
    "Content-Type": "application/json",
    "x-access-token": `${localStorage.getItem("token")}`
  };
  const recipeList = await axios.post(
    `${apiBaseURL}/api/v1/admin/getrecipes`,
    { searchBy: "" },
    {
      headers: headers
    }
  );
  if (recipeList.data) {
    const { recipes } = recipeList.data.data;
    const allrecipes = recipes.map((value) => {
      return {
        id: value?._id,
        name: `${value?.name}`
      };
    });
    return allrecipes;
  }
};
